// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cookie-notice-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.cookie-notice {
  width: 100%;
  background-color: var(--background);
  color: var(--text-primary);
  padding: 1.5rem;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  max-height: 80vh;
  overflow-y: auto;
}

.cookie-notice-content {
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cookie-notice-text {
  flex: 1 1;
}

.cookie-notice-text h3 {
  margin: 0 0 0.75rem 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-primary);
}

.cookie-notice-text p {
  margin: 0.5rem 0;
  font-size: 0.9rem;
  line-height: 1.4;
  color: var(--text-primary);
}

.cookie-notice-text ul {
  margin: 0.5rem 0;
  padding-left: 1.5rem;
  font-size: 0.9rem;
  color: var(--text-primary);
}

.cookie-notice-text a {
  color: var(--theme);
  text-decoration: underline;
  text-underline-offset: 2px;
  font-weight: 500;
  transition: opacity 0.2s ease;
}

.cookie-notice-text a:hover {
  opacity: 0.8;
}

.cookie-notice-text a:active {
  opacity: 0.6;
}

.cookie-notice-button {
  width: 100%;
  padding: 1rem;
  background-color: var(--theme);
  color: var(--text-secondary);
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-weight: 500;
  font-size: 1rem;
  transition: opacity 0.2s;
  margin-top: 0.5rem;
}

.cookie-notice-button:active {
  opacity: 0.8;
}

/* Make text more readable on smaller devices */
@media (max-width: 380px) {
  .cookie-notice {
      padding: 1rem;
  }

  .cookie-notice-text {
      font-size: 0.85rem;
  }

  .cookie-notice-text h3 {
      font-size: 1.1rem;
  }

  .cookie-notice-text ul {
      padding-left: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/CookieNotice.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,0BAA0B;EAC1B,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,+CAA+C;AAC/C;EACE;MACI,aAAa;EACjB;;EAEA;MACI,kBAAkB;EACtB;;EAEA;MACI,iBAAiB;EACrB;;EAEA;MACI,oBAAoB;EACxB;AACF","sourcesContent":[".cookie-notice-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 100000;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.cookie-notice {\n  width: 100%;\n  background-color: var(--background);\n  color: var(--text-primary);\n  padding: 1.5rem;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.cookie-notice-content {\n  max-width: 600px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.cookie-notice-text {\n  flex: 1;\n}\n\n.cookie-notice-text h3 {\n  margin: 0 0 0.75rem 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.cookie-notice-text p {\n  margin: 0.5rem 0;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  color: var(--text-primary);\n}\n\n.cookie-notice-text ul {\n  margin: 0.5rem 0;\n  padding-left: 1.5rem;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n}\n\n.cookie-notice-text a {\n  color: var(--theme);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  font-weight: 500;\n  transition: opacity 0.2s ease;\n}\n\n.cookie-notice-text a:hover {\n  opacity: 0.8;\n}\n\n.cookie-notice-text a:active {\n  opacity: 0.6;\n}\n\n.cookie-notice-button {\n  width: 100%;\n  padding: 1rem;\n  background-color: var(--theme);\n  color: var(--text-secondary);\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 1rem;\n  transition: opacity 0.2s;\n  margin-top: 0.5rem;\n}\n\n.cookie-notice-button:active {\n  opacity: 0.8;\n}\n\n/* Make text more readable on smaller devices */\n@media (max-width: 380px) {\n  .cookie-notice {\n      padding: 1rem;\n  }\n\n  .cookie-notice-text {\n      font-size: 0.85rem;\n  }\n\n  .cookie-notice-text h3 {\n      font-size: 1.1rem;\n  }\n\n  .cookie-notice-text ul {\n      padding-left: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
